import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDevices();
  }, []);

  const fetchDevices = async () => {
    try {
      const response = await axios.get('/api/devices');  // Proxy tự gọi localhost:5000
      setDevices(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching devices:', error);
      setLoading(false);
    }
  };

  const addDevice = async () => {
    // Test POST – Thay bằng form thật sau
    try {
      await axios.post('/api/devices', {
        barcodeId: 'PC002',
        type: 'may-in',
        name: 'Printer 1',
        installDate: '2025-01-01',
        warrantyEndDate: '2026-01-01',
        ownerId: 'fake-id',  // Thay bằng thật
        components: [],
        history: [{ event: 'lap-dat', description: 'New printer' }]
      });
      fetchDevices();  // Refresh list
    } catch (error) {
      console.error('Error adding device:', error);
    }
  };

  if (loading) return <div className="container mt-5"><h2>Loading...</h2></div>;

  return (
    <div className="container mt-5">
      <h1>Quản Lý Tài Sản - Devices</h1>
      <button className="btn btn-primary mb-3" onClick={addDevice}>Thêm Device Test</button>
      <ul className="list-group">
        {devices.map(device => (
          <li key={device._id} className="list-group-item">
            <strong>{device.name}</strong> (ID: {device.barcodeId}) - Type: {device.type}
            <br />Components: {device.components.map(c => c.type).join(', ')}
          </li>
        ))}
      </ul>
      {devices.length === 0 && <p>Chưa có device nào. Thử thêm!</p>}
    </div>
  );
}

export default App;